
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/converter/powerpoint-to-ai",
      function () {
        return require("private-next-pages/converter/powerpoint-to-ai.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/converter/powerpoint-to-ai"])
      });
    }
  